import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  Divider,
  Button,
  Box,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export default function MemberSubscriptionCard({ subscriptions = [] }) {
  // Filter out subscriptions that are not ACTIVE/PAUSED or have been cancelled/scheduled for cancellation
  const visibleSubscriptions = subscriptions.filter((sub) => {
    const hasCancelAction = sub.actions?.some((a) => a.type === "CANCEL");
    return (sub.status === "ACTIVE" || sub.status === "PAUSED") && !sub.canceledDate && !hasCancelAction;
  });

  return (
    <Card sx={{ margin: 2, padding: 2 }}>
      <CardHeader title="My Membership" sx={{ pb: 0 }} />
      <CardContent>
        {/* Always show the View Membership button */}
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <Button
            component={RouterLink}
            to="/dashboard/membership"
            variant="contained"
            sx={{
              textTransform: 'none',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              padding: { xs: '4px 8px', sm: '6px 12px' },
            }}
          >
            View Membership
          </Button>
        </Box>
        {visibleSubscriptions.length ? (
          <List>
            {visibleSubscriptions.map((sub, index) => (
              <React.Fragment key={index}>
                <ListItem
                  sx={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    paddingBottom: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    gutterBottom
                    sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                  >
                    {sub.planName}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                  >
                    <strong>Status:</strong> {sub.status}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                  >
                    <strong>Start Date:</strong> {formatDate(sub.startDate)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                  >
                    <strong>End Date:</strong> {formatDate(sub.endDate)}
                  </Typography>
                </ListItem>
                {index < visibleSubscriptions.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Typography variant="body1" color="textSecondary">
            No active membership.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
